import type { RiskScannedTimestamps } from '@rtkwlf/asset-data-service';

export const getMaxLastSuccessfulScan = (
  lastSuccessfulScanned?: RiskScannedTimestamps,
) => {
  if (!lastSuccessfulScanned) return undefined;

  const { agent, iva } = lastSuccessfulScanned;

  if (!agent || !iva) return agent ?? iva;

  return agent > iva ? agent : iva;
};
